<template>
  <div class="input-group address-container" :class="{ v2: !!version }">
    <label v-if="title && !isHideTitle" :for="dir+'Address'">{{ title }}</label>
    <label v-else-if="!isHideTitle && !version" :for="dir+'Address'" class="address-label-title">{{ dir == 'start' ? '어디로 찾아가면 될까요?' : '어디로 배달해 드리면 될까요?' }}</label>

    <slot name="titleSlot"></slot>
    <input type="text" class="input address-input" :readonly="true" tabindex="-1" :id="dir+'Address'"
           :value="address"
           @click="showAddressSearchModal(dir)"
           placeholder="우편번호 찾기"
           @input="$emit('update:address', $event.target.value)"
    >
<!--    <button class="btn btn-primary btn-find-address" type="button" v-if="isApp && !address" @click="openPostCode(dir)">주소 찾기</button>-->
<!--    <div v-if="isApp" :id="dir+'PostWrap'" class="post-wrap"></div>-->
    <input type="text" class="input input-detail-address" tabindex="-1" placeholder="상세주소를 입력해주세요."
           :value="address_detail"
           :ref="'input' + dir + 'Detail'" :class="{ 'hide-opacity': !address, 'height-zero': !address }"
           @keydown.enter.tab="keypressEnter($event, nextStep);"
           @keyup="isShowNextBtn = true"
           @input="$emit('update:address_detail', $event.target.value)"
    >

    <slot name="side"></slot>
    <ul v-if="!version" class="noti-list">
      <li class="guide pt-3">현재는 강남구, 송파구, 서초구, 성동구 지역만 서비스를 제공하고 있습니다.</li>
      <li class="guide">서울 타지역은 고객센터 - 카카오 문의를 통해 문의 주세요.</li>
      <li class="guide">서울 외 지방은 안타깝게도 서비스 확장 중에 있습니다. 최대한 빨리 찾아 갈게요.</li>
    </ul>

    <label v-if="isIncludeFloor">층수</label>
    <div class="floor-row" v-if="isIncludeFloor">
      <input type="number" class="input address-input" tabindex="-1"
             :value="floor"
             placeholder="층수"
             @input="$emit('update:floor', Number.isNaN(Number($event.target.value)) ? 1 : Number($event.target.value))">
      <select class="input address-input" tabindex="-1"
             :value="carriage_type"
             @change="$emit('update:carriage_type', $event.target.value)">
        <option value="STAIRS">계단</option>
        <option value="EV">엘리베이터</option>
      </select>
    </div>
  </div>
  <Modal v-if="!extendMobilePopup" @close="addressModal = false" class="address-modal" :class="{ hide: !addressModal }">
    <div class="modal-header">주소검색</div>
    <div class="modal-body text-center" :id="dir+'PostWrap'"></div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: "TheEstimateStepForAddress",
  components: { Modal },
  props: [
    'dir', 'nextStep', 'curStep',
    'address', 'address_detail',
    'sigungu', 'bname', 'zipcode', 'floor', 'carriage_type',
    'keypressEnter', 'goStep', 'title', 'isHideTitle',
    'version', 'isIncludeFloor',
    'extendMobilePopup', 'showMobileAddressModal', 'closeMobileAddressModal',
    'areaRestriction'
  ],
  emits: [
    'update:address',
    'update:address_detail',
    'update:sigungu',
    'update:bname',
    'update:zipcode',
    'update:floor',
    'update:carriage_type'
  ],
  data() {
    return {
      isShowNextBtn: false,
      isShowPost: false,
      isApp: false,
      addressModal: false,
      isAreaRestriction: typeof this.areaRestriction === 'undefined' ? true : this.areaRestriction
    }
  },
  methods: {
    showAddressSearchModal(key) {
      if (this.isApp) {
        if (this.extendMobilePopup) this.showMobileAddressModal();
        else this.addressModal = true;
      }
      this.openPostCode(key);
    },
    openPostCode(key) {

      let onComplete = (data) => {
        try {
          let fullRoadAddr = data.roadAddress;
          let extraRoadAddr = '';

          if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
            extraRoadAddr += data.bname;
          }

          if (data.buildingName !== '' && data.apartment === 'Y') {
            extraRoadAddr += (extraRoadAddr !== '' ? ', ' + data.buildingName : data.buildingName);
          }

          if (extraRoadAddr !== '') {
            extraRoadAddr = ' (' + extraRoadAddr + ')';
          }

          if (fullRoadAddr !== '') {
            fullRoadAddr += extraRoadAddr;
          } else if (data.jibunAddress !== '') {
            fullRoadAddr = data.jibunAddress;
          }

          this.$helper.sendGA('estimate_sigungu', { target: data.sigungu });
          if (data.sigungu !== '강남구' && data.sigungu !== '송파구' && data.sigungu !== '서초구' && data.sigungu !== '성동구' && this.isAreaRestriction) {
            return alert("죄송합니다.\n" +
                "현재는 강남구, 송파구, 서초구, 성동구 지역만 서비스를 제공하고 있습니다.\n" +
                "서울 타 지역은 고객센터 - 카카오 문의를 통해 문의 주세요.\n" +
                "서울 외 지방은 안타깝게도 서비스 확장 중에 있습니다. 최대한 빨리 찾아 갈게요.");
          }

          if (data.sigungu) {
            console.log('data.sigungu: '+data.sigungu);
            this.$emit('update:sigungu', data.sigungu);
          }

          if (data.bname) {
            this.$emit('update:bname', data.bname);
          }

          this.$emit('update:zipcode', data.zonecode);
          this.$emit('update:address', fullRoadAddr);
        } catch (e) {
          console.log(data);
          console.error(e);
        }
      };

      let onClose = (state) => {
        if (state === 'COMPLETE_CLOSE') {
          console.log('COMPLETE_CLOSE');
          if (key === 'start') {
            // console.log('start complete');
            this.$refs.inputstartDetail.focus();
          } else if (key === 'all') {
            // console.log('dest complete');
            this.$refs.inputallDetail.focus();
          } else {
            // console.log('dest complete');
            this.$refs.inputdestDetail.focus();
          }
        }

        this.isShowPost = false;
        if (this.addressModal) this.addressModal = false;
        if (this.extendMobilePopup) this.closeMobileAddressModal();
      };

      if (this.isApp) {
        this.isShowPost = true;
        let id = this.extendMobilePopup ? this.extendMobilePopup : this.dir + 'PostWrap';
        let wrap = document.getElementById(id);

        new window.daum.Postcode({
          oncomplete: onComplete,
          onclose: onClose,
          width: '100%',
        }).embed(wrap);
      } else {
        new window.daum.Postcode({
          oncomplete: onComplete,
          onclose: onClose
        }).open();
      }
    },
  },
  mounted() {
    this.isApp = window.innerWidth < 1024;

    window.addEventListener('resize', () => {
      this.isApp = window.innerWidth < 1024;
    });
    // this.isApp = /Mobi/i.test(window.navigator.userAgent);
    // this.isApp = true;
  }
}
</script>

<style scoped lang="scss">
.btn-find-address {
  height: 3rem;
}

.post-wrap {
  margin-bottom: 12px;
}

.height-zero {
  height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute;
}

.input-group label {
  font-size: 20px;
}

.guide {
  clear: both;
  color: #7f7f7f;
  line-height: 1.71;
  font-size: 14px;
  margin: 0;
}
.input-group {
  clear: both;

  input+input {
    margin-top: 12px;
  }

  @include respond(lg-desktop) {
    margin-top: 14px;
  }
}

.height-zero+.guide {
  padding-top: 0 !important;
}

.v2.input-group {
  label {
    font-size: 12px;
    font-weight: 900;
    margin-bottom: 8px;
    line-height: 17px;
    display: inline-block;
  }

  .input {
    height: 40px;
    padding: 10px 13px;
    font-size: 12px;
    border-radius: 5px;
  }
}

input + label {
  margin-top: 20px;
}

.floor-row {
  display: flex;
  justify-content: space-between;

  > * {
    width: 49%;
    vertical-align: top;
  }
}

@include respond(mobile) {
  .address-label-title {
    padding-right: 130px;
  }

  .address-modal {
    .modal-body {
      padding: 0.5rem 1rem 0;

      max-height: 400px;
      overflow: auto;
    }
  }

  .guide {
    font-size: 12px;
  }

  .address-container {
    input {
      font-size: 13px;
    }
  }
}

</style>

<style lang="scss">
.post-wrap > div {
  width: 100% !important;
}

.address-modal {
  //.modal-window {
  //  padding-left: 1.5rem;
  //  padding-right: 1.5rem;
  //}

  .modal-body {
    width: 100%;
  }
}

</style>
